import React from 'react';
import { SubscriptionSelectModal } from './SubscriptionSelectModal';

export const PropozePlusUpgradeModal: React.FC<ModalProps> = ({ onClose }) => {
  return <SubscriptionSelectModal onClose={onClose} />;
};
